module.exports = __webpack_public_path__ + "img/Catalao.09dd4187.png";